export function getIsTouchDevice() {
  return (
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.maxTouchPoints > 0)
  );
}
